module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Dimitri Verhulst\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("DIMITRI VERHULST is the Belgium author of a collection of short stories, a volume of poetry, and several novels including "), _c('I', [_vm._v("Madame Verona Comes Down the Hill ")]), _vm._v("and "), _c('I', [_vm._v("Problemski Hotel")]), _vm._v(".")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/lw4Kem/tc-custom/9781250035172.jpg?1728259163733",
      "alt": "This image is the cover for the book Misfortunates"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Misfortunates\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("Frank, tender, and brutally funny, Dimitri Verhulst's semi-autobiographical story details the vibrantly entertaining journey of a boy growing up in a family of alcoholics in Belgium"), _c('br'), _c('br')]), _vm._v("Sobriety and moderation are alien concepts to the men in Dimmy's family. Useless in all other respects, his three uncles have a rare talent for drinking, a flair for violence, and an unwavering commitment to the pub. And his father Pierre is no slouch either. Within hours of his son's birth, Pierre plucks him from the maternity ward, props him on his bike, and takes him on an introductory tour of the village bars. His mother soon leaves them to it and as Dimmy grows up amid the stench of stale beer, he seems destined to follow the path of his forebears and make a low-life career in inebriation, until he begins to piece together his own plan for the future."), _c('br'), _c('br'), _vm._v("Bringing to life the shambolic upbringing that The Guardian describes as, \"the odd, ugly, excremental poetry of their grubby lives,\" "), _c('i', [_vm._v("The Misfortunates")]), _vm._v(" \"can be unexpectedly tender as well as uncomfortably funny… this novel continually surprises and intrigues.\"")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    St. Martin’s Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0